import { createElement } from 'react';
import { SvgNumber1, SvgNumber2, SvgNumber3 } from '@parcel2go/core-ui';
import { TFunction } from 'i18next';

export const buildQuickSendSteps = (t: TFunction<string, string>) => [
  {
    label: t('QUICK_SEND_STEP_1_LABEL', { defaultValue: 'Add recipient address' }),
    detail: t('QUICK_SEND_STEP_1_DETAIL', { defaultValue: "Where it's going" }),
    icon: createElement(SvgNumber1)
  },
  {
    label: t('QUICK_SEND_STEP_2_LABEL', { defaultValue: 'Describe your parcel' }),
    detail: t('QUICK_SEND_STEP_2_DETAIL', { defaultValue: 'Weight, size, and contents' }),
    icon: createElement(SvgNumber2)
  },
  {
    label: t('QUICK_SEND_STEP_3_LABEL', { defaultValue: 'Save order, ready to ship' }),
    detail: t('QUICK_SEND_STEP_3_DETAIL', { defaultValue: 'All ready to select a service from the top couriers' }),
    icon: createElement(SvgNumber3)
  }
];
